import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { CSVLink } from 'react-csv';

import { FaEdit, FaFileExport } from 'react-icons/fa';
import { MdCheckCircle, MdRemoveCircle } from 'react-icons/md';

import { switchOffer, changeActive } from './mutation';
import { getAllOffersByAdmin } from './queries';
import { Dialog } from '../../../components';
import FilterFromToV2 from '../../../components/Filter/FilterFromToV2';
import styles from './styles';
import { colors } from '../../../constants';
import classNames from 'classnames';

import { Subscription } from 'react-apollo';
import { subOfferEdited } from '../Subscription';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

class TableOffer extends Component {
  state = {
    open: false,
    title: '',
    content: '',
    name: '',
    userName: '',
    offerStartFrom: '',
    offerStartTo: '',
    offerEndFrom: '',
    offerEndTo: '',
    activeFilter: '',
    publicFilter: '',
    page: 0,
    limit: 15
  };

  onDataRefetch(){
    const { listOfferRefetch } = this.props;
    listOfferRefetch.refetch()
  }

  componentDidMount(){
    this.onDataRefetch()
  }

  componentDidUpdate(){
    this.onDataRefetch()
  }

  //TODO: VER TKT CLOS-248 cancelado por violar operacion de activar o desactivar usuario
  /*changeStatus = row => {
    const offerId = row.id;
    const statusOffer = row.status === 'PUBLISHED';
    const { switchOffer } = this.props;
    switchOffer({
      variables: {
        offerId,
        statusOffer: !statusOffer
      },
      refetchQueries: [{ query: getAllOffersByAdmin }]
    })
      .then(res => {
        if (res)
          this.setState({
            open: true,
            content: 'Completed',
            title: 'Change Status Offer'
          });
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: 'Error Change Status Offer'
          });
        }
      });
  };*/

  onChangeActive = (row, active) => {
    const { id } = row;
    const { changeActive } = this.props;
    changeActive({
      variables: {
        id,
        active
      },
      refetchQueries: [{ query: getAllOffersByAdmin }]
    })
      .then(res => {
        if (res)
          this.setState({
            open: true,
            content: 'Completed',
            title: 'Change Active Offer'
          });
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: 'Error Change Active Offer'
          });
        }
      });
  };

  onOk = () => {
    this.setState({ open: false });
  };

  handleFilterInpChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value, page: 0 });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ limit: event.target.value });
  };

  filter = (data) => {
    const {
      name,
      userName,
      offerStartFrom,
      offerStartTo,
      offerEndFrom,
      offerEndTo,
      activeFilter,
      publicFilter,
    } = this.state;

    if (name) {
      data = _.filter(data, (obj) =>
        obj.title ? obj.title.toLowerCase().includes(name.toLowerCase()) : false
      );
    }

    if (userName) {
      data = _.filter(data, (obj) => {
        const merchantUsername = obj.merchant && obj.merchant.username
          ? obj.merchant.username.toLowerCase()
          : '';
        return merchantUsername.includes(userName.toLowerCase());
      });
    }

    if (activeFilter === 'active') {
      data = _.filter(data, (obj) => obj.active !== false);
    } else if (activeFilter === 'deactive') {
      data = _.filter(data, (obj) => obj.active === false);
    }

    if (publicFilter === 'public') {
      data = _.filter(data, (obj) => obj.status === 'PUBLISHED');
    } else if (publicFilter === 'pause') {
      data = _.filter(data, (obj) => obj.status !== 'PUBLISHED');
    }

    if (offerStartFrom) {
      data = _.filter(data, (obj) => {
        if (!obj.offerStartDetail) return false;
        return moment.utc(obj.offerStartDetail).isSameOrAfter(offerStartFrom, 'day');
      });
    }

    if (offerStartTo) {
      data = _.filter(data, (obj) => {
        if (!obj.offerStartDetail) return false;
        return moment.utc(obj.offerStartDetail).isSameOrBefore(offerStartTo, 'day');
      });
    }

    if (offerEndFrom) {
      data = _.filter(data, (obj) => {
        if (!obj.offerEndDetail) return false;
        return moment.utc(obj.offerEndDetail).isSameOrAfter(offerEndFrom, 'day');
      });
    }

    if (offerEndTo) {
      data = _.filter(data, (obj) => {
        if (!obj.offerEndDetail) return false;
        return moment.utc(obj.offerEndDetail).isSameOrBefore(offerEndTo, 'day');
      });
    }

    return data;
  };

  prepareDataForCSV = () => {
    const { listAllOffer } = this.props;
    let data = listAllOffer || [];
    data = _.orderBy(data, (obj) => obj.id, 'desc');
    data = this.filter(data);

    return data.map((offer) => ({
      Name: offer.title || '',
      'User Name': offer.merchant && offer.merchant.username ? offer.merchant.username : '',
      Category: offer.category ? offer.category.name : '',
      Quantities: offer.quantities != null ? offer.quantities : '',
      'Offer Price': offer.offerPrice != null ? offer.offerPrice : '',
      Sale: offer.saleOff != null ? offer.saleOff : '',
      'Offer Start': offer.offerStartDetail
        ? moment.utc(offer.offerStartDetail).format('MM/DD/YYYY')
        : '',
      'Offer End': offer.offerEndDetail
        ? moment.utc(offer.offerEndDetail).format('MM/DD/YYYY')
        : '',
      Active: offer.active === false ? 'Deactive' : 'Active',
      Public: offer.status === 'PUBLISHED' ? 'Public' : 'Pause',
      Online: offer.status === 'PUBLISHED' && offer.active !== false ? 'Yes' : 'No',
    }));
  };

  onExportToCSV = () => {
    if (this.csvLinkRef) {
      this.csvLinkRef.link.click();
    }
  };

  renderFilter = () => {
    const { classes } = this.props;
    const {
      name,
      userName,
      offerStartFrom,
      offerStartTo,
      offerEndFrom,
      offerEndTo,
      activeFilter,
      publicFilter,
    } = this.state;

    return (
      <div key="filter">
        <div className={classes.filterRow}>
          <FilterFromToV2
            label="Name"
            fromField={
              <TextField
                name="name"
                value={name}
                onChange={this.handleFilterInpChange}
                placeholder="Name"
              />
            }
            resetFn={() => this.setState({ name: '', page: 0 })}
            smallButton
          />
          <FilterFromToV2
            label="User Name"
            fromField={
              <TextField
                name="userName"
                value={userName}
                onChange={this.handleFilterInpChange}
                placeholder="User Name"
              />
            }
            resetFn={() => this.setState({ userName: '', page: 0 })}
            smallButton
          />
          <FilterFromToV2
            label="Active"
            fromField={
              <Select
                name="activeFilter"
                onChange={this.handleFilterInpChange}
                value={activeFilter}
                displayEmpty
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="deactive">Deactive</MenuItem>
              </Select>
            }
            resetFn={() => this.setState({ activeFilter: '', page: 0 })}
            smallButton
          />
          <FilterFromToV2
            label="Public"
            fromField={
              <Select
                name="publicFilter"
                onChange={this.handleFilterInpChange}
                value={publicFilter}
                displayEmpty
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="public">Public</MenuItem>
                <MenuItem value="pause">Pause</MenuItem>
              </Select>
            }
            resetFn={() => this.setState({ publicFilter: '', page: 0 })}
            smallButton
          />
        </div>
        <div className={classes.filterRow}>
          <FilterFromToV2
            label="Offer Start"
            fromField={
              <TextField
                name="offerStartFrom"
                type="date"
                value={offerStartFrom}
                onChange={this.handleFilterInpChange}
                placeholder="From"
                InputLabelProps={{ shrink: true }}
              />
            }
            toField={
              <TextField
                name="offerStartTo"
                type="date"
                value={offerStartTo}
                onChange={this.handleFilterInpChange}
                placeholder="To"
                InputLabelProps={{ shrink: true }}
              />
            }
            resetFn={() => this.setState({ offerStartFrom: '', offerStartTo: '', page: 0 })}
            smallButton
          />
          <FilterFromToV2
            label="Offer Ends"
            fromField={
              <TextField
                name="offerEndFrom"
                type="date"
                value={offerEndFrom}
                onChange={this.handleFilterInpChange}
                placeholder="From"
                InputLabelProps={{ shrink: true }}
              />
            }
            toField={
              <TextField
                name="offerEndTo"
                type="date"
                value={offerEndTo}
                onChange={this.handleFilterInpChange}
                placeholder="To"
                InputLabelProps={{ shrink: true }}
              />
            }
            resetFn={() => this.setState({ offerEndFrom: '', offerEndTo: '', page: 0 })}
            smallButton
          />
        </div>
      </div>
    );
  };

  renderToolBar = () => {
    const { classes } = this.props;
    return (
      <div className={classes.searchWrapper}>
        <Button
          variant="contained"
          color="primary"
          className={classNames(classes.buttonActive, classes.exportButton)}
          onClick={this.onExportToCSV}
        >
          <Typography component="p" className={classes.text}>
            Export Filtered to CSV
          </Typography>
          <FaFileExport color="#ffffff" size={16} />
        </Button>
        <CSVLink
          data={this.prepareDataForCSV()}
          filename={`offers-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
          style={{ display: 'none' }}
          ref={(r) => { this.csvLinkRef = r; }}
        >
          Export
        </CSVLink>
      </div>
    );
  };

  render() {
    const { classes, listAllOffer } = this.props;
    let data = listAllOffer || [];
    data = _.orderBy(data, obj => obj.id, 'desc');
    data = this.filter(data);
    const { title, content, open, page, limit } = this.state;
    return (
      <div>
        <Dialog
          title={title}
          content={content}
          open={open}
          onOk={() => this.onOk()}
        />
        {this.renderFilter()}
        {this.renderToolBar()}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell>Title</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Category
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Quantities
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Offer Price
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Sale
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Online
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.rowEdit}>
                  Detail
                </CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>
                  Public/Pause
                </CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>
                  Active/Deactive
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * limit, page * limit + limit).map(row => {
                return (
                  <TableRow className={classes.row} key={row.id}>
                    <CustomTableCell component="th" scope="row">
                      {row.title}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.category ? row.category.name : 'Sin categoría'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.quantities}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.offerPrice}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.saleOff}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.status === 'PUBLISHED' &&
                      (row.active === true || row.active == null) ? (
                        <MdCheckCircle color={colors.dark} size={16} />
                      ) : (
                        <MdRemoveCircle color={colors.red} size={16} />
                      )}
                    </CustomTableCell>
                    <CustomTableCell
                      align="center"
                      className={classes.columCenter}
                    >
                      <Link to={{ pathname: `/detailOffer/${row.id}` }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          <Typography component="p" className={classes.text}>
                            Detail
                          </Typography>
                          <FaEdit color="#ffffff" size={16} />
                        </Button>
                      </Link>
                    </CustomTableCell>
                    <CustomTableCell
                      align="center"
                      className={classes.columCenter}
                    >
                      {row.status !== 'PUBLISHED' ? (
                        <Button
                          variant="contained"
                          color="primary"
                          disableRipple = {true}
                          disableElevation = {true}                          
                          className={classNames(classes.buttonDeactive, classes.noElevateDeactive)}
                        >
                          <Typography component="p" className={classes.text}>
                            Pause
                          </Typography>
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          disableRipple = {true}
                          disableElevation = {true}
                          className={classNames(classes.buttonActive, classes.noElevateActive)}
                        >
                          <Typography component="p" className={classes.text}>
                            Public
                          </Typography>
                        </Button>
                      )}
                    </CustomTableCell>

                    <CustomTableCell
                      align="center"
                      className={classes.columCenter}
                    >
                      {row.active === false ? (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonDeactive}
                          onClick={() => this.onChangeActive(row, true)}
                        >
                          <Typography component="p" className={classes.text}>
                            Deactive
                          </Typography>
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonActive}
                          onClick={() => this.onChangeActive(row, false)}
                        >
                          <Typography component="p" className={classes.text}>
                            Active
                          </Typography>
                        </Button>
                      )}
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={data.length}
            rowsPerPage={limit}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />

          <Subscription
            subscription={subOfferEdited}            
            onSubscriptionData={({ subscriptionData }) => {
              this.onDataRefetch()
            }}>          
          </Subscription>

        </Paper>

      </div>
    );
  }
}
// Mark: default props
TableOffer.defaultProps = {
  classes: {},
  listAllOffer: [],
  listOfferRefetch: () => {},
  switchOffer: () => {},
  changeActive: () => {}
};

// Mark: PropsType
TableOffer.propTypes = {
  classes: PropTypes.object,
  listAllOffer: PropTypes.array,
  listOfferRefetch: PropTypes.func,
  switchOffer: PropTypes.func,
  changeActive: PropTypes.func
};

// Mark: Map data grapql to props
const ListAllOffer = graphql(getAllOffersByAdmin, {
  props: ({ data }) => ({
    loading: data.loading,
    listAllOffer: data.getAllOffersByAdmin
  })
});
const Switch = graphql(switchOffer, { name: 'switchOffer' });
const listOfferRefetch = graphql(getAllOffersByAdmin, { name: 'listOfferRefetch' });
const ChangeActive = graphql(changeActive, { name: 'changeActive' });
export default withStyles(styles)(
  compose(
    ListAllOffer,
    listOfferRefetch,
    Switch,
    ChangeActive
  )(TableOffer)
);
